import { SearchInput } from '../shared';
import { SortOrder, ProjectSortType } from '../enums';

export class GetProjectsInput extends SearchInput<ProjectSortType> {
    constructor() {
        super(ProjectSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}